export const SEARCH_CONSOLE_DOMAIN_PREFIX = "sc-domain:";
